import { render, staticRenderFns } from "./CollectionReport.vue?vue&type=template&id=3323b6ed&"
import script from "./CollectionReport.vue?vue&type=script&lang=js&"
export * from "./CollectionReport.vue?vue&type=script&lang=js&"
import style0 from "./CollectionReport.vue?vue&type=style&index=0&id=3323b6ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports